<template>
  <section class="row">
    <div class="col-12">
      <div class="card">
        <div
          class="card-body px-md-4 py-md-5 rounded-4 py-4 transition-shadow
            box-shadow-green-300 box-shadow-hover-green-300"
        >
          <div class="row">
            <div class="col-1 pe-0">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-10 d-flex flex-column">
              <div class="h5 text-center mb-3">
                Vos RIB
              </div>
              <p>
                Vous pouvez choisir votre RIB principal en modifiant l’ordre ci-dessous.
                Pour cela, cliquez sur un RIB et glissez-le vers le haut ou vers le
                bas pour modifier l’ordre de priorité.
              </p>
              <div class="d-flex mx-auto mb-3">
                <img
                  v-if="bankAccounts.length === 0"
                  :src="`${aws}/unicorn-magnifying-glass.png`"
                  alt="Assurup image loupe"
                  class="img-fluid"
                >
              </div>
            </div>
            <div
              class="col-12 col-md-10 mx-auto"
              :class="{ 'my-4': bankAccounts.length > 0 }"
            >
              <transition-group name="flip-list">
                <v-iban-display
                  v-for="bankAccount in bankAccounts"
                  :key="bankAccount.uniqueId"
                  :bank-account="bankAccount"
                  class="mb-3"
                  @error="(value) => error = value"
                />
              </transition-group>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <v-loader
                :next="() => $router.push('/client/account/payments/sepa/add')"
                icon="plus-white"
                title="Ajouter un nouveau RIB"
                class="w-100 mx-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SepaDisplay from '../helpers/SepaDisplay.vue';

export default {
  name: 'AccountPaymentSepa',
  components: {
    'v-iban-display': SepaDisplay,
  },
  computed: {
    bankAccounts() {
      const paymentMethodIbans = (this.$store.getters['payments/paymentMethods'] || [])
        .filter(({ type }) => type === 'IBAN')
        .map((paymentMethod) => ({
          ...paymentMethod,
          source: 'paymentMethod',
          uniqueId: `paymentMethod-${paymentMethod.id}`,
        }));

      const goCardlessIbans = (this.$store.getters['payments/goCardlessBankAccounts'] || [])
        .map((bankAccount) => ({
          ...bankAccount,
          source: 'goCardless',
          uniqueId: `goCardless-${bankAccount.id}`,
        }));

      const bankAccounts = [...paymentMethodIbans, ...goCardlessIbans];
      return bankAccounts.toSorted(({ active: a }, { active: b }) => Number(b) - Number(a));
    },
    activeBankAccount() {
      return this.bankAccounts.find(({ active }) => active);
    },
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png`,
  },
  async mounted() {
    const results = await Promise.allSettled([
      this.$store.dispatch('payments/getPaymentMethods'),
      this.$store.dispatch('payments/getGoCardlessBankAccounts'),
    ]);

    results
      .filter(({ status }) => status === 'rejected')
      .forEach(({ reason }) => this.$emit('error', reason));
  },
};
</script>
<style scoped>
.flip-list-move {
  transition: transform 1s;
}
</style>
